import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import { fetchAuthSession } from 'aws-amplify/auth';
var getAuthJWT = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var authJWT, _tokens$idToken$toStr, _tokens$idToken, _yield$fetchAuthSessi, tokens;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          authJWT = null;
          _context.prev = 1;
          _context.next = 4;
          return fetchAuthSession();
        case 4:
          _yield$fetchAuthSessi = _context.sent;
          tokens = _yield$fetchAuthSessi.tokens;
          authJWT = (_tokens$idToken$toStr = tokens === null || tokens === void 0 || (_tokens$idToken = tokens.idToken) === null || _tokens$idToken === void 0 ? void 0 : _tokens$idToken.toString()) !== null && _tokens$idToken$toStr !== void 0 ? _tokens$idToken$toStr : null;
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          authJWT = null;
        case 12:
          return _context.abrupt("return", authJWT);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function getAuthJWT() {
    return _ref.apply(this, arguments);
  };
}();
export default getAuthJWT;